// extracted by mini-css-extract-plugin
export var errorIcon = "_k5-1";
export var nameLogo = "_k5-0";